const isSupported = 'mediaCapabilities' in window.navigator

const MediaCapabilities = {
  isMP3Supported: async (): Promise<boolean | null> => {
    if (!isSupported) {
      return null
    }

    const res = await window
      .navigator
      .mediaCapabilities
      .decodingInfo({
        type: 'media-source',
        audio: { contentType: 'audio/mpeg' }
      })

    return res.supported
  },
  isMP4Supported: async (): Promise<boolean | null> => {
    if (!isSupported) {
      return null
    }

    const res = await window
      .navigator
      .mediaCapabilities
      .decodingInfo({
        // @ts-expect-error - Nem támogatott a 'codecs' tulajdonság.
        type: 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"'
      })

    return res.supported
  }
}

export default MediaCapabilities
